import { render, staticRenderFns } from "./CustomerPortalOrderHistory.vue?vue&type=template&id=fd00cad0&scoped=true&"
import script from "./CustomerPortalOrderHistory.vue?vue&type=script&lang=js&"
export * from "./CustomerPortalOrderHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd00cad0",
  null
  
)

export default component.exports